module.exports = {"610631100":"石堡镇","610631101":"白马滩镇","610631102":"瓦子街镇","610631106":"界头庙镇","610631107":"三岔镇","610631205":"圪台乡","610631206":"崾崄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610631.json
// module id = 2845
// module chunks = 0